import request from '@/utils/request'

// 设备类型
export const deviceApi = {
    // 获取分类列表
    pageTypeList : (data) => request.post('/chemical/device/type/page',data),
    // 保存或者更新
    saveOrUpdate : (data) => request.post('/chemical/device/type/saveOrUpdate',data),
}

// 审批类型
export const approvalApi = {
    // 获取列表
    pageApprovalList : (data) => request.post('/chemical/device/approval/page',data),
    // 获取详情
    detailApprovalById : (id) => request.get(`/chemical/device/approval/detail/${id}`),
    // 审批
    auditApproval : (data) => request.post(`/chemical/device/approval`,data),
}

// 危化品信息
export const chemicalApi = {
    // 危化品列表
    pageChemicalList : (data) => request.post('/chemical/chem/info/page',data),
    // 危化品详情
    getDetailById : (id) => request.get(`/chemical/chem/info/${id}`),
}
